import "../style/exam-result/ER_SummaryResult.css";

let data2 = [
  {
    id: 1,
    name: "آزمون جامع یازدهم",
    date: "1400/06/23",
    correct_choice_num: 10,
    incorrect_choice_num: 5,
    empty_choice_num: 5,
    choice_num: 20,
    rank: 100,
  },
];

const ER_SummaryResult = ({ data }) => {
  data = data || {};
  return (
    <div className="er-summary-result">
      <div className="er-summary-result-title">خلاصه نتایج</div>
      <div className="er-summary-result-title-row">
        <div className="er-summary-result-title-row-item">نام آزمون</div>
        <div className="er-summary-result-title-row-item">تاریخ برگزاری</div>
        <div className="er-summary-result-title-row-item">
          تعداد گزینه‌های درست
        </div>
        <div className="er-summary-result-title-row-item">
          تعداد گزینه‌های نادرست
        </div>
        <div className="er-summary-result-title-row-item">
          تعداد گزینه‌های نزده
        </div>
        <div className="er-summary-result-title-row-item">تعداد سوالات</div>
        <div className="er-summary-result-title-row-item">رتبه کل</div>
      </div>
      <div className="er-summary-result-data-row">
        <div className="er-summary-result-data-row-item">{data.title}</div>
        <div className="er-summary-result-data-row-item">{data2[0].date}</div>
        <div className="er-summary-result-data-row-item">
          {data2[0].correct_choice_num}
        </div>
        <div className="er-summary-result-data-row-item">
          {data2[0].incorrect_choice_num}
        </div>
        <div className="er-summary-result-data-row-item">
          {data2[0].empty_choice_num}
        </div>
        <div className="er-summary-result-data-row-item">
          {data2[0].choice_num}
        </div>
        <div className="er-summary-result-data-row-item">{data2[0].rank}</div>
      </div>
    </div>
  );
};

export default ER_SummaryResult;
